import { Button, Divider, Form, Input, Select, Space } from 'antd'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { Icon } from '../../'
import { translations } from '../../../constants'
import { trimFields } from '../../../utils'

const JpForm = ({
  hideModal,
  isFormNeedPaymentMethods = true,
  locale = 'us',
  onSubmit,
  selectedStore,
}) => {
  const initialValues = { accountType: 'CURRENT', store_id: selectedStore.id }
  const [form] = Form.useForm()
  const [isModalLoading, setModalLoading] = useState(false)

  const accountTypeOptions = [
    { label: translations[locale].current, value: 'CURRENT' },
    { label: translations[locale].savings, value: 'SAVINGS' },
    { label: translations[locale].checking, value: 'CHECKING' },
  ]

  const handleSubmit = () => {
    const isFormUpdated = form.isFieldsTouched()

    if (isFormUpdated) {
      form
        .validateFields()
        .then(() => {
          setModalLoading(true)

          const requiredFieldsValue = {
            ...trimFields(form.getFieldsValue()),
            store_id: selectedStore.id,
          }

          onSubmit({
            country: 'jp',
            requiredFieldsValue,
            setModalLoading,
          })
        })
    }
  }

  return (
    <Form
      data-test="bank-details-form"
      data-testid="jpForm"
      form={form}
      initialValues={initialValues}
      layout="vertical"
      onFinish={handleSubmit}
    >
      <Form.Item
        className="bankDetailsBankCode"
        label={translations[locale].bankCode}
        name="bankCode"
        rules={[
          {
            message: translations[locale].addBankCode,
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        className="bankDetailsBranchCode"
        label={translations[locale].branchCode}
        name="branchCode"
        rules={[
          {
            message: translations[locale].addBranchCode,
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        className="bankDetailsAccountType"
        label={translations[locale].accountType}
        name="accountType"
        rules={[
          {
            message: translations[locale].addAccountType,
            required: true,
          },
        ]}
      >
        <Select options={accountTypeOptions} />
      </Form.Item>

      <Form.Item
        className="bankDetailsAccountNumber"
        label={translations[locale].accountNumber}
        name="accountNumber"
        rules={[
          {
            message: translations[locale].addAccountNumber,
            required: true,
          },
          {
            message: translations[locale].addValidAccountNumber,
            min: 7,
          },
          {
            max: 7,
            message: translations[locale].addValidAccountNumber,
          },
          {
            message: translations[locale].accountNumberType,
            pattern: /^[0-9]+$/,
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={translations[locale].legalEntity}
        name="legal_entity"
        rules={[{ message: 'Please enter the Legal Entity!', required: true }]}
        tooltip={{ icon: <Icon type="infoCircle" />, title: translations[locale].legalEntityTooltip }}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={translations[locale].reportingEmail}
        name="reporting_email"
        rules={[
          {
            message: translations[locale].addReportingEmail,
            type: 'email',
          },
          {
            message: translations[locale].addValidReportingEmail,
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Divider />

      <Space
        size="middle"
        style={{
          display: 'flex',
          justifyContent: 'end',
        }}
      >
        {isFormNeedPaymentMethods && <Button className="bankDetailsCancel" name="cancelBtnSelenium" onClick={hideModal}>Cancel</Button>}
        <Button className="bankDetailsSubmit" htmlType="submit" loading={isModalLoading} name="submitBtnSelenium" type="primary">{translations[locale].submit}</Button>
      </Space>
    </Form>
  )
}

JpForm.propTypes = {
  hideModal: PropTypes.func,
  isFormNeedPaymentMethods: PropTypes.bool,
  locale: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  selectedStore: PropTypes.object.isRequired,
}

export default JpForm
